import type { FaireProductEntity } from "../../entity_types/product";

export const p_nttjt6p6c2: FaireProductEntity = {
  token: "p_nttjt6p6c2",
  type: "product",
  name: "Oversized Hooded Knit Cardigan",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/73513f51555b2308474df7dd574718a610272a953681d026101c9cbfe17828ae.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88cd9c90251eccad423dae1907a9f42179e790ee3033d9ee68cca032e7340842.jpeg",
    "https://cdn.faire.com/fastly/ce3e742828aef76665d13a9685f649dff7e804a0152ab40eee0687f45d93f538.jpeg",
    "https://cdn.faire.com/fastly/79461ba05283ab8c0d061393938342e31bcf73bebf6d9ad29dd8945b498df6dc.jpeg",
    "https://cdn.faire.com/fastly/7d5d139a9e5b1dce3812549928662814314bf14be435a9ce796e324adfc8363f.jpeg",
    "https://cdn.faire.com/fastly/ef1e61d551ee9bdce133e953fbf07bad6e5bf01ee03468e44df66d7e0f15c716.jpeg",
    "https://cdn.faire.com/fastly/e31036b3bbcbd329b5873ab7bd71a9af39369b2f499ad49ab81c806f6a8b5021.jpeg",
    "https://cdn.faire.com/fastly/5c1034007605faeae847bdfa3f511c3b0286bebbd62dd59b89723224124ab8a9.jpeg",
    "https://cdn.faire.com/fastly/e721b73bb0d8cf7751a30cb991c184511fbfbadd27b24cae6e005a94cb3f0bc1.jpeg",
    "https://cdn.faire.com/fastly/354bd90d75878eb9ad6df96fd1a6c9c1d94e3b2884d397cd85108c21c1d074d9.png",
  ],
  priceDollars: 48,
  description:
    "WRAP UP IN ULTIMATE COMFORT AND EFFORTLESS STYLE WITH THIS OVERSIZED HOODED CARDIGAN, FEATURING A SOFT KNIT CONSTRUCTION AND A RELAXED SILHOUETTE FOR THE PERFECT COZY LAYER.\n\nFeatures:\n\nIMPORTED, DESIGNED IN USA\n\nMATERIAL: CONT 100% ACRYLIC\n\nULTRA-SOFT KNIT FABRIC PROVIDES A WARM AND COMFORTABLE DRAPE FOR ALL-DAY RELAXATION\n\nSINGLE-BUTTON CLOSURE AND ATTACHED HOOD OFFER MINIMALIST STYLE AND PRACTICAL COMFORT\n\nShape & Fit:\n\nOversized, Relaxed Fit\n\nLong Sleeves with Attached Hood\n\nExtended Hem Length\n\nSizing:\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\n#cardigan #hoodedcardigan #oversizedcardigan #knitwear #cozyseason #loungewear #weekendwear #softknit #athomewear #comfortfashion #winterfashion #fallstyle #layeringpiece #minimaliststyle #casualchic #relaxedfit #wfhfashion #streetwear #easyoutfit #versatilelayer #chillvibes #warmwear #fashionknit #acrylicknit #hoodiealternative #blanketcardigan #seasonlesslayer #comfortzone #styleandcomfort\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:11.352Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
